<template>
  <div class="root" style="width: 640px; margin:0 auto; font-size:0.8em;">
    <a href="javascript:window.print()" class="print-button">Print Report</a>
    <div class="row">
      <div class="form-group col-3">
        <div id="logo-report"></div>
      </div>
      <div class="form-group col-9">
        <div class="pb-3 bd-highlight" style="font-size: 2rem;"><b>Dental Place </b></div>
        <div class="p-0 bd-highlight">Jl. Boulevard Raya No. 8 AL</div>
        <div class="p-0 bd-highlight">Komplek Cemara Asri,</div>
        <div class="p-0 bd-highlight">Medan</div>
        <div class="p-0 bd-highlight">tlp. 0813 6586 2006</div>
        <div class="p-0 bd-highlight">Email. Dentalplace.id@gmail.com</div>
      </div>
    </div>
    
    <div id="borderline"></div>
    <!-- <hr class="border-top: 0px solid #8c8b8b;"> -->
    <p style="font-size:20px;color:black;"><b>Invoice</b></p>
    <div class="judul"> 
      <!-- <div class="row" style="padding:0 0em;">
        <div class="master col-4" style="border-radius: 5px;"> Invoice : {{ invoice.invoiceNo }} </div>
        <div class="master col-3 offset-5" style="border-radius: 5px;"> TGL : {{moment(invoice.date).format("DD MMMM YYYY")}} </div>
      </div>
      <br> -->
      <!-- <div class="row">
        <div class="col-4" style="text-align:left;"> Invoice : {{ invoice.invoiceNo }} </div>
        <div class="col-6 offset-2" style="border-radius: 0px; text-indent: 40%; padding: 0px;"> Medan, {{moment(invoice.invoiceDate).format("DD MMMM YYYY")}} </div>
      </div>
      <br /> -->
      <div class="row">
        <div class="col-4" style="text-align:left;"> Invoice : {{ invoice.invoiceNo }} </div>
        <div class="col-6 offset-2" style="text-align:right;" >Medan, {{moment().format("DD MMMM YYYY")}}  </div>
      </div>
      <br>
      <div class="row">
        <div class="col-9" style="text-align:left;"> Kepada : {{ (invoice.patientQq) ? invoice.patientQq + ' QQ ' + invoice.patientName  : invoice.patientName }} </div>
      </div>
        <hr class="border-top: 1px solid #8c8b8b;">
        <div id="report-table">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th scope="col">Keterangan</th>
                <th scope="col">Anamnesa/Diagnosa</th>
                <th scope="col">Regio</th>
                <th scope="col">Harga</th>
                <th scope="col">Diskon</th>
                <th scope="col">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for=" (list, index) in invoice.detail" v-bind:key = "index">
                <td width="200" style="text-align:left;">{{ list.treatmentName }}</td>
                <td width="200" style="text-align:left;">{{ list.description }}</td>
                <td width="200" style="text-align:left;">{{ list.teeth }}</td>
                <td width="200">{{numeral(list.totalAfterPercent).format('0,0.00')}}</td>
                <td width="200" style="text-align:right;">{{ 'Rp.' + numeral(list.discount).format('0,0.00')}}</td>
                <td width="200" style="text-align:right;">{{ 'Rp.' + numeral(list.totalAfterPercent - list.discount).format('0,0.00')}}</td>
              </tr>
            </tbody>
          </table>
          <hr class="border-top: 1px solid #8c8b8b;">
        </div>
      </div>
    <div class="row" style="padding:0 1em;">
      <div class="col-3 offset-6" style="text-align:right;" > Sub Total :  </div>
      <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(invoice.subTotal).format('0,0.00')}} </div>
    </div>
    <div class="row" style="padding:0 1em;">
      <div class="col-3 offset-6" style="text-align:right;" > Diskon :  </div>
      <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(invoice.totalDiscount).format('0,0.00')}} </div>
    </div>
    <div class="row" style="padding:0 1em;">
      <div class="col-3 offset-6" style="text-align:right;" > Grand Total :  </div>
      <div class="col-3" style="text-align:right;" > {{ 'Rp.' + numeral(invoice.grandTotal).format('0,0.00')}} </div>
    </div>
    <br/><br/><br/>
    <div class="row" style="padding:0 1em;">
      <div class="col-3 offset-9" style="text-align:right;" ><b> Tanda Tangan Dokter</b></div>
      <br/>
      <div class="col-3 offset-9" style="text-align:right;" id="sign-report"></div>
      <br/>
      <div class="col-3 offset-9" style="text-align:right;" ><b> Drg. Angel</b></div>
      <br/>
      <div class="col-3 offset-9" style="text-align:right;" ><b> BV00000389265321</b></div>
      <br/>
      <div class="col-4 offset-8" style="text-align:right;" ><b> 035687 02 01 070050</b></div>
    </div>
    <!-- <br/><br/><br/>
    <div class="row" style="padding:0 1em;">
      <div class="col-4 offset-6">
        <div>
          <table class="table table-bordered table-sm">
            <thead>
            <tr>
              <th scope="col">Tanda Tangan Dokter</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><br/><br/><br/><br/><br/></td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import api from '../../services/api'
import { Invoice } from '../../models/invoice'
import AppLookupField from '../../components/AppLookupField.vue'
import AppDatatable from '../../components/AppDatatable.vue'
import AppDatePicker from '../../components/AppDatePicker.vue'
import AppDropdown from '../../components/AppDropdown.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import html2canvas from 'html2canvas'

export default {
  components: {
    AppLookupField, AppDatatable, AppDatePicker, AppDropdown, AppNavBar
  },
  data() {
    return {
      invoice: {...Invoice, detail: []},
    }
  },
  async created() {
    if(this.$route.query.id !== undefined) {
      const invoiceReportApi = api('invoice/print')
      this.invoice = await invoiceReportApi.getWithParams(this.$route.query.id)
    }
  },
  methods: {
    async exportToPdf() {
      const input = document.getElementById('report-to-print')
      const canvas = await html2canvas(input, {
        width: 1450,
        height: 1000
      })
      const imgData = canvas.toDataURL('image/png')

      const pdf = new jsPDF('l', 'mm', 'a4')
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      const currentTime = Date.now()
      pdf.addImage(imgData, 'JPEG', 0, 0, pdfWidth, pdfHeight)
      pdf.save(`${this.invoice.patientName}.pdf`)
    }
  }
}
</script>